import { DefaultCarPageComponentProps } from "@/app/interface/components";
import { getVehicleTech } from "@/app/utils/vehiclesInfo";
import Image from "next/image";
import * as React from "react";

type SpecItemProps = {
  label: string;
  value: string;
};

const SpecItem: React.FC<SpecItemProps> = ({ label, value }) => (
  <div className="flex flex-col grow shrink pr-16 min-w-[240px] w-[254px]">
    <div className="flex items-center">
      <span className="flex shrink-0 h-[12px] rounded-full border-2 -mt-1 border-white w-[12px]" />
      <hr className="flex-1 shrink self-stretch h-px border border-white w-[243px]" />
    </div>
    <h3 className="mt-2 text-lg font-semibold text-white">{label}</h3>
    <p className="mt-2 text-base leading-snug text-stone-50">{value}</p>
  </div>
);

function TechSpecs({ car, model, version }: DefaultCarPageComponentProps) {
  const info = getVehicleTech(
    car?.name?.toLocaleLowerCase()?.replaceAll(" ", "-")!,
    model?.name!,
    version?.name!
  );
  const specs = [
    {
      label: "MOTOR",
      value: info?.motor,
    },
    {
      label: "TIPO DE COMBUSTÍVEL",
      value: info?.tipoDeCombustivel,
    },
    {
      label: "CAPACIDADE DE CARGA",
      value: info?.capacidadeDeCarga,
    },
    {
      label: "DESEMPENHO",
      value: info?.desempenho,
    },
    {
      label: "TRANSMISSÃO",
      value: info?.transmissao,
    },
    {
      label: "ÁUDIO MULTIMÍDIA",
      value: info?.audioMultimidia,
    },
  ];

  const getStyleConfig = (modelCar?: string) => {
    switch (modelCar) {
      case "Híbrido":
        return {
          bg: "#0D2370",
          imageSrc:
            "https://sablobsitestoyotaprd.blob.core.windows.net/images/vehicles/fita_ficha_tecnica_vermelha.png",
        };
      case "Esportivo":
        return {
          bg: "#C00611",
          imageSrc:
            "https://sablobsitestoyotaprd.blob.core.windows.net/images/vehicles/fita_ficha_tecnica_azul.png",
        };
      case "hatch":
        return {
          bg: "#1A1A1A",
          imageSrc:
            "https://sablobsitestoyotaprd.blob.core.windows.net/images/vehicles/curva_ficha_tecnica.png",
        };
      case "Plug-in":
        return {
          bg: "#0D2370",
          imageSrc:
            "https://sablobsitestoyotaprd.blob.core.windows.net/images/vehicles/fita_ficha_tecnica_vermelha.png",
        };
      default:
        return {
          bg: "#1A1A1A",
          imageSrc:
            "https://sablobsitestoyotaprd.blob.core.windows.net/images/vehicles/curva_ficha_tecnica.png",
        };
    }
  };

  const styleConfig = getStyleConfig(model?.name);

  return (
    <>
      <div className="flex w-full -mt-32">
        <Image
          width={400}
          height={400}
          src={styleConfig.imageSrc}
          alt="wave"
          className="w-3/5 relative z-0 -mb-1"
        />
      </div>
      <div
        className="flex w-full"
        style={{
          backgroundColor: styleConfig.bg,
        }}
      >
        <div className="mx-auto w-full max-w-[1140px] justify-center">
          <h2 className="flex-1 relative -mt-12 flex gap-0 items-start text-3xl font-semibold leading-none text-white basis-0 min-w-[240px] max-md:max-w-full">
            Ficha técnica
          </h2>
          <section className="flex flex-wrap gap-2.5 items-start py-6 mt-4 w-full max-w-[655px] max-md:max-w-full">
            <div className="flex flex-wrap gap-8 items-start w-[655px] max-md:max-w-full">
              {specs.map((spec, index) => (
                <SpecItem
                  key={spec.label + index}
                  label={spec.label}
                  value={spec.value ?? ""}
                />
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default TechSpecs;
